<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 50px;padding-top: 20px;margin: 0 20px">
      <el-button type="primary" plain icon="el-icon-plus" @click="openAddWork()">新建排班</el-button>
      <el-date-picker v-fixZoom :clearable="false" v-model="selectDate" type="daterange" unlink-panels range-separator="至"
                      start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions2" value-format="yyyy-MM-dd" style="margin-right: 10px; width: 230px">
      </el-date-picker>
      <el-button type="primary" @click="getQueryTable1">查询</el-button>
    </div>
    <div style="max-height: calc(100% - 100px);margin: 0 20px;overflow-y: auto">
      <el-table v-loading="loading" element-loading-text="加载中，请耐心等待。" :data="tableData"
                border style="width: 100%" highlight-current-row ref="singleTable">
        <el-table-column type="index" label="序号" width="70" align="center"></el-table-column>
<!--        <el-table-column prop="id" label="序号" width="70" align="center"></el-table-column>-->
        <el-table-column prop="staff_name" label="护工姓名" min-width="70" align="center"></el-table-column>
        <el-table-column prop="shift_date" label="排班日期" min-width="70" align="center"></el-table-column>
        <el-table-column label="班次类型" min-width="60" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.shift_type_code === 'EARLY'">早班</span>
            <span v-if="scope.row.shift_type_code === 'MID'">中班</span>
            <span v-if="scope.row.shift_type_code === 'LATE'">晚班</span>
            <span v-if="scope.row.shift_type_code === 'NIGHT'">夜班</span>
          </template>
        </el-table-column>
        <el-table-column prop="start_time" label="上班时间" min-width="70" align="center"></el-table-column>
        <el-table-column prop="end_time" label="下班时间" min-width="70" align="center"></el-table-column>
        <el-table-column prop="location_name" label="服务区域" min-width="90" align="center"></el-table-column>
        <el-table-column prop="duty_desc" label="护理内容" min-width="90" align="center"></el-table-column>
        <el-table-column prop="is_substitute" label="是否替班" min-width="60" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.is_substitute">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column prop="remarks" label="备注" min-width="70" align="center"></el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click="openEditWork(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="800px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{ titleShow }}</span>
        <div class="line-title"></div>
      </div>
      <add-edit-work v-model="addEditShow" :workObj="workObj" @updateTable="getQueryTable"></add-edit-work>
    </el-dialog>
  </div>
</template>

<script>
import {queryworkshift} from '../../api/yanglaoyuan/eservice'
import addEditWork from './components/addEditWork.vue'
import {queryorg} from '../../api/organizer'
export default {
  name: 'workShift',
  components: {addEditWork},
  data () {
    return {
      entityId: 0,
      loading: false,
      selectDate: [],
      pickerOptions2: {
        // shortcuts: []
      },
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      addEditShow: false,
      titleShow: '',
      workObj: {
        orgArr: [],
        row: '',
        isAdd: true
      }
    }
  },
  created () {
    this.entityId = this.$store.state.user.LoginResp.entity_id
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    let start = new Date().format('yyyy-MM-dd')
    let end = this.commonType.GetDateStr(7).format('yyyy-MM-dd')
    this.selectDate = [start, end]
    this.getQueryTable()
    this.getOrgData()
  },
  methods: {
    getOrgData () {
      queryorg().then(res => {
        this.workObj.orgArr = res.data.org
      }).catch(() => {})
    },
    // 时间
    mGetDate (year, month) {
      const d = new Date(year, month, 0)
      return d.getDate()
    },
    getTimeObj () {
      const dataArr = []
      const data = new Date()
      data.setMonth(data.getMonth() + 1, 1)// 获取到当前月份,设置月份
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + (m))
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + '-' + arr[1] + '-01'
        obj.end = arr[0] + '-' + arr[1] + '-' + endDay
        endDate.push(obj)
      }
      const arrTime = [
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions2.shortcuts = arrTime
    },
    openAddWork () {
      this.titleShow = '新建排班'
      this.workObj.row = ''
      this.workObj.isAdd = true
      this.addEditShow = true
    },
    openEditWork (row) {
      this.titleShow = '编辑排班'
      this.workObj.row = row
      this.workObj.isAdd = false
      this.addEditShow = true
    },
    getQueryTable1 () {
      this.currentPage = 1
      this.pageSize = 10
      this.getQueryTable()
    },
    getQueryTable () {
      this.loading = true
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        eid: this.entityId,
        start_date: this.selectDate[0],
        end_date: this.selectDate[1]
      }
      queryworkshift(params, data).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.shifts
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getQueryTable()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getQueryTable()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/workShift.vue